import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageEmptyPocketsSvg';

export const ResponsesImageEmptyPockets = createResponsesImage({
  name: 'ResponsesImageEmptyPockets',
  component,
});
